export default __webpack_public_path__ + "7f65400c6b61f9dd1187ca51784b2c4f.woff2";